export var svgBundle: string = require("./svgbundle.html");